import React, { useEffect, useState, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import { useLanguageContext } from "../../Context/LanguageContext";
import CommonHeader from "../WebInspection/CommonHeader";
import {
  IconButton,
  Card,
  CardContent,
  Typography,
  Chip,
  Box,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import TabsActions from "../../Actions/TabsActions";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import DetailInspectionView from "../Equipment-Details/DetailInspectionView";

const useStyles = makeStyles((theme) => ({
  accountIconButton: {
    padding: 0,
  },
  accountIcon: {
    width: "3rem",
    height: "3rem",
  },
  headerStyle: {
    padding: 8,
  },
}));

export default function InspectionOverview({
  anlageid,
  equipmentDetails,
  isUserLogged,
  logoutClick,
  handleBack,
}) {
  const { localization } = useLanguageContext();
  const [inspectionSetting, setInspectionSetting] = useState(
    equipmentDetails.inspectionDisplaySetting,
  );
  const [inspectionList, setInspectionList] = useState([]);
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const classes = useStyles();
  const [openInspectionForm, setOpenInspectionForm] = useState(false);
  const [inspectionId, setInspectionId] = useState("");
  const [inspectionDetails, setInspectionDetails] = useState("");

  const fetchInspectionData = useCallback(() => {
    setGlobalSpinner(true);
    if (anlageid !== null && anlageid !== undefined) {
      TabsActions.getAuftragDetails(
        anlageid,
        "ALL",
        equipmentDetails.inspectionHistoryLimit || 50,
      );
    }
  }, [anlageid, equipmentDetails.inspectionHistoryLimit, setGlobalSpinner]);

  useEffect(() => {
    fetchInspectionData();
  }, [fetchInspectionData]);

  useEffect(() => {
    function getInspectionListSuccess() {
      const res = tabsStore.getResult();
      if (res) {
        let temp = res.map((item) => {
          item["nio"] = item["nio"] ? "true" : "false";
          return item;
        });
        setInspectionList(temp);
      }
      setGlobalSpinner(false);
    }

    function getInspectionListFailure() {
      setInspectionList([]);
      setGlobalSpinner(false);
    }

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
      getInspectionListSuccess,
    );

    tabsStore.addChangeListener(
      tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
      getInspectionListFailure,
    );

    return () => {
      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
        getInspectionListSuccess,
      );

      tabsStore.removeChangeListener(
        tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
        getInspectionListFailure,
      );
    };
  }, [setGlobalSpinner]);

  const getStatusChip = (nioValue) => {
    // const isPassed = {inspectionDetails?.nio.toLowerCase() == "true"
    //           ? localization.failedInspection
    //           : localization.passedInspection}
    const backgroundColor = nioValue == "true" ? "#FBE3E3" : "#E3FBE3";
    const textColor = nioValue == "true" ? "#A00" : "#0A470A";

    const nioText =
      nioValue == "true" ? localization.failed : localization.passed;
    return (
      <Chip
        label={nioText}
        style={{
          backgroundColor: backgroundColor,
          color: textColor,
        }}
        className="inspection-card-status"
        variant="outlined"
      />
    );
  };

  const getInspectionDetails = (row) => {
    setInspectionDetails({
      checklistTitle: row.title,
      pruefer: row.pruefer,
      frequency: row.frequency,
      endDate: row.endDate,
      nio: row.nio,
      nextCheckDate: row.nextCheckDate,
    });
    setInspectionId(row.id);
    setOpenInspectionForm(true);
  };

  return (
    <>
      <div className="inspection-overview-container">
        {isUserLogged ? (
          <div className="row justify-content-end">
            <CommonHeader
              logoutClick={() => {
                logoutClick(false);
              }}
              classes={classes}
            />
          </div>
        ) : (
          <div className="row justify-content-start">
            <IconButton onClick={handleBack}>
              <ArrowBack />
            </IconButton>
          </div>
        )}

        <div className="inspection-overview-content">
          <div className="inspection-list-container">
            {inspectionList && inspectionList.length > 0 ? (
              inspectionList.map((inspection, index) => (
                <Card
                  key={inspection.id || index}
                  className="inspection-card"
                  onClick={() => getInspectionDetails(inspection)}
                >
                  <Box className="inspection-card-content">
                    <Typography className="inspection-card-title">
                      {inspection.title}
                    </Typography>
                    <Typography className="inspection-card-date">
                      {inspection.endDate}
                    </Typography>
                  </Box>
                  {getStatusChip(inspection.nio)}
                </Card>
              ))
            ) : (
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", padding: "20px" }}
              >
                {localization.noRecordFound || "No inspections available"}
              </Typography>
            )}
          </div>
        </div>
      </div>

      {openInspectionForm && (
        <DetailInspectionView
          open={openInspectionForm}
          onClose={() => setOpenInspectionForm(false)}
          inspectionDetails={inspectionDetails}
          inspectionId={inspectionId}
          equipmentDetails={equipmentDetails}
          isUserLogged={isUserLogged}
        />
      )}
    </>
  );
}
